export const ROUTE_HOME = "/";
export const ROUTE_PRESENTER_LIST = "/presenter-list";
export const ROUTE_ITEM_LIST = "/item-list";
export const ROUTE_NOTE_LIST = "/note-list";
export const ROUTE_PRESENTER_DETAIL = "/presenter-detail/:id";
export const ROUTE_LOGOUT = "/logout";